/**
 * Created by dimah on 09/08/17.
 */

import { IUserB2B } from '@signature-it/ngx-generic/interfaces';
import { SignedUserDTO } from './user-signed';

// @dynamic
export class B2BUserDTO extends SignedUserDTO implements IUserB2B {
    is_groupmanager: boolean;
    external_account_code: string;
    user_number: string;
    user_account_limit: number;
    c_da: string;

    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes || {};

        this.entity_type = 'b2b';
        this.type = 'b2b';
        this.is_groupmanager = Number(attributes['is_groupmanager']) === 1;
        this.external_account_code = attributes['external_account_code'] || '';
        this.user_number = attributes['user_number'] || '';
        this.user_account_limit = attributes['user_account_limit'] ? parseFloat(attributes['user_account_limit']) : 0;
        this.c_da = attributes['c_da'] ? attributes['c_da'] : 0;
    }

    static createFromArray(collection: any): any[] {
        return (collection || []).map((attributes: object) => {
            return B2BUserDTO.create(attributes || {});
        });
    }

    hasAccessChangeACL(): boolean {
        return this.hasAcl('OrgChangeACL');
    }

    hasAccessCreateManager(): boolean {
        return this.is_groupmanager && (Number(this.external_account_code) > 0 || this.external_account_code != '');
    }

    hasAccessCreateUser(): boolean {
        return this.hasAcl('OrgCreateUser');
    }
    hasAccessSeeSubUsers(): boolean {
        return this.hasAcl('OrgSeeSubUsers') || this.hasAcl('CreateAndSelectOperator');
    }

    isB2B(): boolean {
        return true;
    }


}
